'use client';

import { PurchaseHistory } from '@/types/purchase-history';
import { commonFetch, CommonFetchResponse } from '@/utils/common-fetch';

class TransactionsApiService {
  private readonly transactionsUrl = '/papi/profiles/me/transactions';

  async getTransactions(): Promise<CommonFetchResponse<PurchaseHistory[]>> {
    const response = await commonFetch<PurchaseHistory[]>(this.transactionsUrl);
    return response;
  }
}

export const transactionsApiService = new TransactionsApiService();
